function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  z-index: 2;\n  top: 50%;\n  left: 50%;\n  width: 3.75em;\n  height: 3.75em;\n  margin: 0.375em 0 0 -2em;\n  background: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import { ThemePropType, defaultTheme } from '../constants';
var WeatherContainer = styled.div.attrs({
  'data-e2e': 'weather-container'
})(_templateObject(), function (props) {
  return props.theme.backgroundColor;
});
WeatherContainer.propTypes = {
  theme: ThemePropType
};
WeatherContainer.defaultProps = {
  theme: defaultTheme
};
WeatherContainer.displayName = 'WeatherContainer';
export default WeatherContainer;